export default {
    DATA_LOADED: "DATA_LOADED",
    NO_ENTITY_RECOMMENDED: "NO_ENTITY_RECOMMENDED",
    ENTITY_SELECTED: "ENTITY_SELECTED",
    ENTITY_TOGGLED: "ENTITY_TOGGLED",
    ENTITY_DESELECTED: "ENTITY_DESELECTED",
    ENTITY_EXPANDED: "ENTITY_EXPANDED",
    ATTRIBUTE_SELECTED: "ATTRIBUTE_SELECTED",
    ATTRIBUTE_TOGGLED: "ATTRIBUTE_TOGGLED",
    ATTRIBUTE_DESELECTED: "ATTRIBUTE_DESELECTED",
    RELATIONS_LOADED: "RELATIONS_LOADED",
    RELATION_SELECTED: "RELATION_SELECTED",
    RELATION_DESELECTED: "RELATION_DESELECTED",
    COLD_START: "COLD_START",
    NEXT_ENTITY_SET_LOADED: "NEXT_ENTITY_SET_LOADED",
    START_LOADING: "START_LOADING",
    ENTITY_RECOMMENDED: "ENTITY_RECOMMENDED",
    TOGGLE_SHOW_MORE_OPTION: "TOGGLE_SHOW_MORE_OPTION",
    RELATIONS_SELECTED: "RELATIONS_SELECTED",
    RELATIONS_DESELECTED: "RELATIONS_DESELECTED",
    TOGGLE_SELECT_ALL_ENTITIES: "TOGGLE_SELECT_ALL_ENTITIES",
    TOGGLE_SHOW_LIBRARY_ATTRIBUTES: "TOGGLE_SHOW_LIBRARY_ATTRIBUTES",
    TOGGLE_SHOW_ORGANIZATION_ATTRIBUTES: "TOGGLE_SHOW_ORGANIZATION_ATTRIBUTES",
    CUSTOM_ENTITIES_CHANGED: "CUSTOM_ENTITIES_CHANGED",
    SET_CREATING_DATA: "SET_CREATING_DATA",
    RELATION_SWAP: "RELATION_SWAP",
}